<template>
    <div class="newAddressWrap">
        <div class="content fc">
            <div class="row fr ac">
                <span>收货人</span>
                <input v-model="realName" type="text" placeholder="请输入收货人姓名" />
            </div>
            <div class="row fr ac">
                <span>联系电话</span>
                <input v-model="phoneNo" type="text" placeholder="请输入收货人联系电话" />
            </div>
            <div class="row fr ac" @click="togglePicker">
                <span>城市区域</span>
                <p v-if="province && city && county">{{province+" "+city+" "+county}}</p>
                <p v-else class="grey">请选择城市区域</p>
            </div>
            <div class="wideRow fr">
                <span>详细地址</span>
                <textarea v-model="detailedAddr" id rows="10" placeholder="请输入详细地址"></textarea>
            </div>
            <div @click="switchDefault" class="row fr ac jsb">
                <p>设为默认地址</p>
                <img class="select" :src="isDefault ? selectedIco : ''" alt />
            </div>
            <div v-show="isEdit" class="del center">
                <button @click="delAddress">删除</button>
            </div>
            <transition name="picker">
                <county-picker
                    v-show="showPicker"
                    @getVal="getCountyVal"
                    @confirmPick = "togglePicker"
                    :regionInit="regionInit"
                    :provinceTxt="province"
                    :cityTxt="city"
                    :countyTxt="county"
                ></county-picker>
            </transition>
            <div v-show="showPicker" @click="togglePicker" @touchmove.prevent class="shade"></div>
        </div>
        <button @click="saveAddress" class="confirm bg_tc">保存</button>
    </div>
</template>

<script>
import countyPicker from "../../components/common/countyPicker.vue";
import { MessageBox, Toast } from "mint-ui";
export default {
    data() {
        return {
            isEdit: this.$route.query.isEdit ? this.$route.query.isEdit : false,
            isDefault:
                this.$route.query.info &&
                JSON.parse(this.$route.query.info).isdefault == "N"
                    ? false
                    : true,
            selectedIco: require("../../../static/imgs/movie/duigou_orange.png"),
            showPicker: false,
            province:
                this.$route.query.info &&
                JSON.parse(this.$route.query.info).provincename
                    ? JSON.parse(this.$route.query.info).provincename
                    : "",
            city: "",
            county: "",
            provincecode: "",
            citycode: "",
            countycode: "",
            regionInit: false,
            realName:
                this.$route.query.info &&
                JSON.parse(this.$route.query.info).realname
                    ? JSON.parse(this.$route.query.info).realname
                    : "",
            phoneNo:
                this.$route.query.info &&
                JSON.parse(this.$route.query.info).mobile
                    ? JSON.parse(this.$route.query.info).mobile
                    : "",
            detailedAddr:
                this.$route.query.info &&
                JSON.parse(this.$route.query.info).address
                    ? JSON.parse(this.$route.query.info).address
                    : "",
            addressid:
                this.$route.query.info && JSON.parse(this.$route.query.info).id
                    ? JSON.parse(this.$route.query.info).id
                    : "",
            provinceTxt: "",
            countyTxt: "",
            cityTxt: "",
            addressid: ""
        };
    },
    components: {
        countyPicker
    },
    created() {
        if (this.$route.query.info) {
            console.log(JSON.parse(this.$route.query.info));
            // this.provinceTxt = JSON.parse(this.$route.query.info).provincename
            // this.countyTxt = JSON.parse(this.$route.query.info).countyname
            // this.cityTxt = JSON.parse(this.$route.query.info).cityname
            this.province = JSON.parse(this.$route.query.info).provincename;
            this.county = JSON.parse(this.$route.query.info).countyname;
            this.city = JSON.parse(this.$route.query.info).cityname;
            this.provincecode = JSON.parse(this.$route.query.info).provincecode;
            this.citycode = JSON.parse(this.$route.query.info).citycode;
            this.countycode = JSON.parse(this.$route.query.info).countycode;
            this.addressid = JSON.parse(this.$route.query.info).id;
        }
    },
    methods: {
        switchDefault() {
            this.isDefault = !this.isDefault;
        },
        togglePicker() {
            this.showPicker = !this.showPicker;
            this.regionInit = true;
        },
        getCountyVal(
            province,
            city,
            county,
            provincecode,
            citycode,
            countycode
        ) {
            this.province = province;
            this.city = city;
            this.county = county;
            this.provincecode = provincecode;
            this.citycode = citycode;
            this.countycode = countycode;
        },
        saveAddress() {
            this.$post({
                method: "member.drama.express.address.add",
                auth_code: this.getLocal("auth_code"),
                realname: this.realName,
                mobile: this.phoneNo,
                provincename: this.province,
                cityname: this.city,
                countyname: this.county,
                address: this.detailedAddr,
                isdefault: this.isDefault ? 1 : 0,
                provincecode: this.provincecode,
                citycode: this.citycode,
                countycode: this.countycode,
                addressid: this.addressid
            }).then(res => {
                if (res.success) {
                    this.$router.go(-1);
                }
                if (this.isEdit) {
                    Toast({
                        message: "修改成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                } else {
                    Toast({
                        message: "添加成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        },
        delAddress() {
            MessageBox.confirm("确定删除此收货地址?")
                .then(action => {
                    if (action == "confirm") {
                        this.confirmDelAddress();
                    }
                })
                .catch(err => {
                    // this.restSlide();
                });
        },
        confirmDelAddress() {
            this.$post({
                method: "member.drama.express.address.del",
                auth_code: this.getLocal("auth_code"),
                addressid: this.addressid
            }).then(res => {
                if (res.success) {
                    this.removeLocal("selectedAddress");
                    this.$router.go(-1);
                }
            });
        }
    }
};
</script>
<style lang="scss">
.newAddressWrap {
    .content {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        background: #fff;
        .row {
            height: 102px;
            font-size: 28px;
            width: 100%;
            border-bottom: 1px solid #dededf;
            span {
                width: 120px;
                margin-right: 20px;
                height: 100px;
                line-height: 100px;
            }
            input {
                width: calc(100% - 140px);
                height: 100px;
                line-height: 40px;
            }
            .select {
                width: 34px;
                height: 34px;
                padding: 2px;
                border: 4px solid #ec642b;
                border-radius: 50%;
            }
        }
        .row:last-of-type {
            border-bottom: none;
        }
        .wideRow {
            height: 202px;
            font-size: 28px;
            width: 100%;
            border-bottom: 1px solid #dededf;
            span {
                width: 120px;
                margin-right: 20px;
                height: 100px;
                line-height: 100px;
            }
            textarea {
                width: calc(100% - 140px);
                height: 200px;
                padding: 30px 0;
                line-height: 40px;
            }
        }
        .del {
            width: 100%;
            height: 120px;
            button {
                width: 120px;
                height: 60px;
                line-height: 60px;
                border: 1px solid #E42F46;
                color: #E42F46;
                font-size: 28px;
                background: #fff;
                border-radius: 8px;
            }
        }
        .picker-enter {
            transform: translateY(960px);
        }
        .picker-enter-active {
            transition: all 0.5s;
        }
        .shade {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 4;
        }
    }
    .confirm {
        width: 100%;
        height: 120px;
        line-height: 120px;
        position: fixed;
        bottom: 0;
        right: 0;
        font-size: 34px;
        color: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/address/newAddress.vue